import { render, staticRenderFns } from "./Category2Select.vue?vue&type=template&id=7e67ce01&"
import script from "./Category2Select.vue?vue&type=script&lang=js&"
export * from "./Category2Select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports